module.exports = __webpack_public_path__ + "img/industry-5.916c40a4.jpg";